import {CommonModule} from "@angular/common";
import {Component, Input} from "@angular/core";
import {RouterModule} from "@angular/router";
import {AppbarStateInterface} from "../../interfaces";
import { UxIcon} from "@trumpf/ux.ui-angular-standalone";

@Component({
  selector: "mtc-appbar",
  templateUrl: "./appbar.component.html",
  styleUrl: "./appbar.component.scss",
  imports: [CommonModule, RouterModule, UxIcon]
})
export class AppbarComponent {
  @Input() public isLoggedIn = false;
  @Input() public state!: AppbarStateInterface;
}
